import React from 'react';
import { Box, Button, Container, Typography, useTheme, useMediaQuery } from '@mui/material';
import { Page } from './Page';
import { NLLError } from 'views/resident/NLL/NLLMedicineList/NLLErrorPage';
import { useTranslation } from 'react-i18next';

type ErrorPageProps = {
  title: string;
  description?: string | undefined;
  shouldReload: boolean;
  buttonText: string;
  nllError?: NLLError;
  onClickHandler?: () => void;
};

function shouldReloadWindow(shouldReload: boolean) {
  if (shouldReload) {
    window.location.reload();
  }
}

function ErrorPage(props: ErrorPageProps) {
  const { title, description, shouldReload, buttonText, nllError, onClickHandler } = props;
  const theme = useTheme();
  const mobileDevice = useMediaQuery(theme.breakpoints.down('md'));
  const { t } = useTranslation('NLL');

  return (
    <Page title="Error page" style={{ display: 'flex', alignItems: 'center' }}>
      <Container maxWidth="lg">
        <Typography align="center" variant={mobileDevice ? 'h4' : 'h1'} color="textPrimary">
          {title}
        </Typography>
        {description && (
          <Typography align="center" variant="subtitle2" color="textSecondary">
            {description}
          </Typography>
        )}
        {nllError && (
          <div style={{ marginTop: theme.spacing(3) }}>
            {nllError.errorMessages && nllError.errorMessages.length > 0 ? (
              <>
                <Typography variant="caption" color="textSecondary" sx={{ display: 'block', textAlign: 'center' }}>
                  {t('NLL:errorDescriptionForMessages', { statusCode: nllError.statusCode })}
                </Typography>
                {nllError.errorMessages.map((message) => {
                  return (
                    <Typography
                      variant="caption"
                      color="textSecondary"
                      sx={{ display: 'block', textAlign: 'center' }}
                      key={message}
                    >
                      {message}
                    </Typography>
                  );
                })}
              </>
            ) : (
              <Typography variant="caption" color="textSecondary" sx={{ display: 'block', textAlign: 'center' }}>
                {t('NLL:errorDefaultMessage', { statusCode: nllError.statusCode })}
              </Typography>
            )}
          </div>
        )}
        {(nllError === undefined ||
          nllError.statusCode === undefined ||
          (nllError.statusCode && nllError.statusCode >= 500)) && (
          <Box mt={3} display="flex" justifyContent="center">
            <Button
              color="primary"
              variant="outlined"
              onClick={onClickHandler ? onClickHandler : () => shouldReloadWindow(shouldReload)}
            >
              {buttonText}
            </Button>
          </Box>
        )}
      </Container>
    </Page>
  );
}

export default ErrorPage;
